module.exports = __webpack_public_path__ + "static/media/avax_to_harm.e51b469b.png";